export default [
    {
        comment: '',
        error_id: 'XS-01',
        data: [
            {
                "cross_section": "32373",
                "tar_cross_section": "31673"
            },
            {
                "cross_section": "31673",
                "tar_cross_section": "32373"
            },
            {
                "cross_section": "28194",
                "tar_cross_section": "27303"
            },
            {
                "cross_section": "27303",
                "tar_cross_section": "28194"
            },
            {
                "cross_section": "26228",
                "tar_cross_section": "25116"
            },
            {
                "cross_section": "25116",
                "tar_cross_section": "26228"
            }
        ]
    },
]